
export interface IPollAnswer {
	text: string;
	count?: number;
	checked?: boolean;
}

export enum PollGraphType {
	BAR,
	PIE,
	NONE,
}
